module.exports = __webpack_public_path__ + "img/dd1.2570e655.jpg";